<template>
  <div class="com-container">
    <div class="toolbar">
      <h2>
        <em></em>
        <span>{{$t("changeEmail.title")}}</span>
      </h2>
    </div>
    <div class="cp-container">
      <section>
        <el-form :model="chgEmailForm" status-icon :rules="chgEmailRule" ref="chgEmailForm" label-width="150px">
          <el-form-item :label="$t('changeEmail.password')" prop="pass">
            <el-input type="password" v-model="chgEmailForm.pass" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
          </el-form-item>
          <el-form-item prop="email" :label="$t('changeEmail.newEmail')">
            <el-input type="email" v-model="chgEmailForm.email" autocomplete="off" @keyup.enter.native="submitForm">
              <el-button
                slot="append"
                @click="getVerifyCode"
              >{{$t("common.sendCode")}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="code" :label="$t('common.verifyCode')">
            <el-input v-model="chgEmailForm.code" @keyup.enter.native="submitForm"></el-input>
            <el-button type class="cp-Btn" @click="submitForm">{{$t("common.submit")}}</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
  </div>
</template>
<script>
import { changeEmail, sendVerifyCode } from "../../request";
import { resCode, pattern } from "../../../server/common/data";
import api from "../../api/api";
const validator = require("validator");

export default {
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.emailRequried')));
      } else {
        if (validator.isEmail(value)) {
          api
            .checkUserExist({ email: value })
            .then(res => {
              if (res.data.CODE !== resCode.USER_NOT_FOUND) {
                callback(new Error(this.$t('signup.emailUsed')));
              } else {
                callback();
              }
            })
            .catch(() => {
              callback();
            });
        } else {
          callback(new Error(this.$t('common.emailFormat')));
        }
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.verifyCodeRequried')));
      } else {
        if (validator.isLength(value, {min: 6, max: 6}) && validator.isAlphanumeric(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.verifyCodeFormat')));
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.passwordRequried')));
      } else {
        if (pattern.password.test(value)) {
          callback();
        } else {
          callback(
            new Error(this.$t('common.passwordFormat')));
        }
      }
    };
    return {
      chgEmailForm: {
        pass: "",
        email: "",
        code: ""
      },
      chgEmailRule: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.chgEmailForm.validate(valid => {
        if (valid) {
          let data = {
            password: this.chgEmailForm.pass,
            email: this.chgEmailForm.email,
            code: this.chgEmailForm.code
          };
          changeEmail(this, data);
        } else {
          return false;
        }
      });
    },
    getVerifyCode() {
      this.$refs.chgEmailForm.validateField("email", err => {
        if (!err) {
          let data = {
            email: this.chgEmailForm.email,
            act: "change email"
          };
          sendVerifyCode(this, data);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cp-container {
  width: 94%;
  margin: 80px 2% 0;
  .el-input {
    width: 410px;
    border-radius: 4px;
  }
  .el-input__inner {
    width: 410px;
    height: 40px;
    border-radius: 2px;
    margin-right: 25px;
    border: solid 1px #d2dcef;
  }
  // .el-input-group {
  //   width: 550px;
  // }
  .el-button el-button--default {
    width: 110px !important;
    height: 38px;
    border: none;
    margin: 0;
    padding: 0;
    font-weight: normal!important;
    text-align: center;
    border-radius: 2px;
  }
  .el-button:hover{
    padding: 0;
    width: 112px;
  }
  .el-button{
    width: 112px;
    padding: 0;
  }
  .el-input-group__append .el-button,
  .el-input-group__append .el-select,
  .el-input-group__prepend .el-button,
  .el-input-group__prepend .el-select {
    margin: 0;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    width: 80px;
    height: 38px;
    border: none;
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    border-radius: 4px;
  }
  .el-form-item__label {
    text-align: left;
    font-weight: bold;
    color: #606e85 !important;
  }
  .cp-Btn {
    width: 112px;
    height: 38px;
    color: #fff;
    border: none;
    font-size: 16px;
    font-weight: normal;
    background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
    border-radius: 4px;
    padding: 0;
    display: inline-block;
    margin: 0 22px;
  }
}
</style>


// WEBPACK FOOTER //
// ChangeEmailAddress.vue?75f62d0f